export default __webpack_public_path__ + "static/media/close-circle-fill.13e1e544.svg";